import React from "react";
import leftImg from "../../../assets/Rectangle 4604.png";

const compensationItems = [
  "Hospital stays and inpatient care",
  "Doctor visits and specialist consultations",
  "Prescription medications",
  "Preventive screenings and wellness visits",
];

export default function Compensation() {
  return (
    <section className="relative text-white font-[Quicksand] w-full bg-[#0A1F8F]">
      <div className="max-w-[1200px] 2xl:max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">

        {/* Desktop / Tablet */}
        <div className="hidden md:flex items-stretch pt-12">

          {/* Image */}
          <div className="w-1/2 overflow-hidden rounded-t-2xl flex items-end pr-6 lg:pr-10">
            <img
              src={leftImg}
              alt="Medicare coverage"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Text */}
          <div className="w-1/2 flex items-center px-6 lg:px-10 py-8 lg:py-10">
            <div className="max-w-[540px]">

              <h2 className="font-semibold leading-snug text-[26px] lg:text-[30px] xl:text-[32px] mb-3">
                What Medicare <span className="text-[#EDC14A]">Can Help Cover</span>
              </h2>

              <p className="text-[16px] lg:text-[17px] xl:text-[18px] leading-relaxed mb-4">
                Once enrolled in the right plan, you may have coverage for:
              </p>

              <ul className="list-disc pl-5 space-y-2 text-[16px] lg:text-[17px] xl:text-[18px] leading-relaxed">
                {compensationItems.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              <p className="text-[15px] lg:text-[16px] xl:text-[17px] mt-4 leading-relaxed opacity-90">
                What's covered and what it costs depends on your plan and your individual situation. That's exactly why getting the right guidance matters.
              </p>

            </div>
          </div>
        </div>

        {/* Mobile */}
        <div className="block md:hidden py-8">

          {/* Image */}
          <div className="overflow-hidden rounded-t-xl">
            <img
              src={leftImg}
              alt="Medicare coverage"
              className="w-full h-[240px] object-cover"
            />
          </div>

          {/* Text */}
          <div className="pt-5">

            <h2 className="text-[23px] font-semibold leading-tight mb-3">
              What Medicare <span className="text-[#EDC14A]">Can Help Cover</span>
            </h2>

            <p className="text-[16px] leading-relaxed mb-4">
              Once enrolled in the right plan, you may have coverage for:
            </p>

            <ul className="list-disc pl-5 text-[16px] leading-relaxed space-y-2">
              {compensationItems.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>

            <p className="text-[15px] leading-relaxed mt-4 opacity-90">
              What's covered and what it costs depends on your plan and your individual situation. That's exactly why getting the right guidance matters.
            </p>

          </div>
        </div>

      </div>
    </section>
  );
}